import { useState } from "react";

const PAGES = [
  {
    id: "admin-list",
    title: "Admin Listesi",
    menuPath: "Admin Paneli → Admin Listesi",
    purpose:
      "Admin hesaplarını listeleme, filtreleme, yeni admin ekleme ve mevcut admin üzerinde temel işlemleri yapma.",
    actions: [
      "Tüm adminleri listeleme",
      "Email veya Rol'e göre filtreleme",
      "Yeni admin ekleme",
      "Görüntüle, Düzenle, Şifreyi Güncelle, Sil işlemleri",
    ],
    steps: [
      "Sol menüden Admin Paneli → Admin Listesi'ni açın.",
      "Email ve/veya Rol filtrelerini kullanarak arama yapın.",
      "Bilgi Getir'e tıklayın.",
      "Filtreleri temizlemek için Sıfırla'ya tıklayın.",
      "Yeni admin eklemek için 'Yeni Admin Ekle' butonuna basın.",
      "Var olan adminler için satırın sağındaki ikonlardan işlem seçin.",
    ],
    iconLegend: ["👁️ Görüntüle", "✏️ Düzenle", "🔑 Şifreyi Güncelle", "🗑️ Sil"],
    tips: [
      "Sayfa başına satır ile sayfadaki kayıt sayısını değiştirebilirsiniz.",
      "Sayfalama oklarıyla kayıtlar arasında gezebilirsiniz.",
    ],
  },
  {
    id: "user-list",
    title: "Kullanıcı Listesi",
    menuPath: "Admin Paneli → Kullanıcı Listesi",
    purpose:
      "Kullanıcı hesaplarını listeleme, filtreleme, yeni kullanıcı ekleme ve mevcut kullanıcı üzerinde işlemler yapma.",
    actions: [
      "Tüm kullanıcıları listeleme",
      "Email, Meta ID veya Tier Tipi'ne göre filtreleme",
      "Yeni kullanıcı ekleme",
      "Kullanıcı bilgilerini düzenleme",
      "Kullanıcıyı silme",
    ],
    steps: [
      "Sol menüden Admin Paneli → Kullanıcı Listesi'ni açın.",
      "Email, Meta ID veya Tier Tipi alanlarını doldurun.",
      "Bilgi Getir'e tıklayın.",
      "Filtreleri temizlemek için Sıfırla'ya tıklayın.",
      "Yeni kullanıcı eklemek için 'Yeni Kullanıcı Ekle' butonuna basın.",
      "Var olan kullanıcılar için satırın sağındaki ikonlardan işlem seçin.",
    ],
    iconLegend: ["👁️ Görüntüle", "✏️ Düzenle", "🗑️ Sil"],
    tips: [
      "Sayfa başına satır ile sayfadaki kayıt sayısını değiştirebilirsiniz.",
      "Sayfalama oklarıyla kayıtlar arasında gezebilirsiniz.",
    ],
  },
  {
    id: "manage-boosts",
    title: "Boost Kuralları",
    menuPath: "Admin Panel → Boost Yönetimi → Boost Kuralları",
    purpose:
      "Haftalık, dönemsel ve özel boost kurallarını listeleme, durumlarını yönetme ve (özel boostlarda) kullanıcılara atama işlemlerini yapma.",
    rules: [
      "Yeni bir weekly veya period boost rule oluşturulduğunda, ilgili tier’lara sahip tüm kullanıcılara otomatik olarak boost assignment atanır.",
      "Bir boost kuralı inactive yapılırsa, aktif assignment’lar iptal edilir ve bağlı açık ticket’lar kapatılır.",
      "Sadece special boost kuralları expire edilebilir. Expire edilen kuralların aktif assignment’ları expire edilir ve ona bağlı tüm açık boost ticket’lar kapatılır.",
      "Weekly boost rule’lar her hafta başında otomatik expire olur ve yenisi oluşturulup tüm kullanıcılara atanır.(Kural expired olduğunda, bağlı active assignment’lar expired olur; bu assignment’lara bağlı open ticket’lar closed olur.)",
      "Period boost rule’lar valid_until süresi dolduğunda otomatik expire olur. Aktif assignment’lar expire edilir ve bağlı açık ticket’lar kapatılır.(Kural expired olduğunda, bağlı active assignment’lar expired olur; bu assignment’lara bağlı open ticket’lar closed olur.)",
      "Sadece special assignment’lar iptal edilebilir. İptal edilen assignment’ların bağlı açık ticket’ları kapatılır.",
      "Yeni bir kullanıcı oluşturulduğunda, active durumdaki weekly ve period kurallar kullanıcı kategorisine göre bu kullanıcıya da assignment olarak atanır.",
      "Bir kullanıcı silindiğinde, kullanıcıya ait active assignment’lar cancelled durumuna alınır ve bu assignment’lara bağlı open ticket’lar closed olur.",
      "Bir assignment’ın kullanım hakkı (kuraldaki quantity) tamamen tüketildiğinde, assignment otomatik olarak used durumuna geçirilir."
    ],
    actions: [
      "Weekly / Special Offer / Period sekmelerinde boostları ayrı ayrı listeleme",
      "Durum'a göre filtreleme",
      "Boost'u Aktif/Pasif yapma",
      "Yeni boost kuralı ekleme",
      "(Sadece Special Offer) Seçili boostu ➕ ikonuyla kullanıcılara atama",
    ],
    steps: [
      "Sol menüden Boost Yönetimi sayfasını açın.",
      "Üstteki sekmelerden 'WEEKLY BOOSTS', 'SPECIAL OFFER BOOSTS' veya 'PERIOD BOOSTS' sekmesini seçin.",
      "İsterseniz 'Durum' filtresini belirleyip Bilgi Getir'e tıklayın.",
      "Yeni kural eklemek için sağ üstteki 'Yeni Boost Kuralı Ekle' butonuna basın ve formu doldurun.",
      "Var olan bir kuralın durumunu değiştirmek için satırdaki Aktif/Pasif kontrolünü kullanın.",
      "(Special Offer) Bir boostu kullanıcıya atamak için ilgili satırı seçin ve ➕ ikonuna tıklayın.",
    ],
    iconLegend: [
      "👁️ Görüntüle: Boost kuralı detayını açar",
      "✏️ Düzenle: Kural üzerinde değişiklik yapar",
      "⏯️ Aktif/Pasif: Boost durumunu değiştirir",
      "➕ Atama (yalnızca Special Offer): Seçili boostu kullanıcılara atar",
    ],
    tips: [
      "Sekmeye göre liste boş görünebilir; doğru sekmede olduğunuzu ve filtreyi kontrol edin.",
      "'Veri yüklenirken bir hata oluştu' uyarısı görürseniz yeniden deneyin; sorun devam ederse yöneticinize bildirin.",
      "Sayfa başına satır ile sayfadaki satır sayısını ayarlayabilir, oklarla sayfalar arasında gezebilirsiniz.",
    ],
  },
  {
    id: "user-boost-list",
    title: "Kullanıcı Boost Listesi",
    menuPath: "Admin Panel → Boost Yönetimi → Kullanıcı Boost Listesi",
    purpose:
      "Kullanıcıların hesaplarına atanmış tüm boostları görüntüleme ve ihtiyaç duyulduğunda filtreleme.",
    actions: [
      "Tüm atanmış boostları listeleme",
      "Email'e göre filtreleme",
      "Kullanıcı Kategorisi'a göre filtreleme",
      "Satırdaki 👁️ ikonuyla kullanıcının atanmış boost detayını görüntüleme",
    ],
    steps: [
      "Sol menüden Boost Yönetimi → User Boost sayfasını açın.",
      "Üstteki alanlardan Email ve/veya Kullanıcı Kategorisi seçin.",
      "Bilgi Getir'e tıklayın; sonuçlar tabloda listelenir.",
      "Filtreleri temizlemek için Sıfırla'ya tıklayın.",
      "İlgili kullanıcının atanmış boostlarını görmek için satırdaki 👁️ ikonuna tıklayın.",
    ],
    iconLegend: ["👁️ Görüntüle: Kullanıcının atanmış boostlarını gösterir"],
    tips: [
      "Sayfa başına satır ile sayfadaki kayıt sayısını ayarlayabilirsiniz.",
      "Sayfalama oklarıyla listedeki diğer kayıtları görüntüleyebilirsiniz.",
    ],
  },
  {
    id: "ticket-list",
    title: "Boost Ticket Listesi",
    menuPath: "Admin Paneli → Boost Yönetimi → Boost Ticket Listesi",
    purpose:
      "Kullanıcı taleplerini (ticket) görme, filtreleme, durumu yönetme ve onaylanan talepleri kullandırma.",
    actions: [
      "Tüm ticket'ları listeleme",
      "User ID, Boost Kategorisi, Boost Tipi ve Durum'a göre filtreleme",
      "Durumu Onayla (APPROVED) veya Reddet (REJECTED)",
      "OPEN ve APPROVED durumlarında ticket detayını görüntüleme",
      "OPEN ve APPROVED durumlarında kullanıcıyla mesajlaşma",
      "APPROVED durumundaki talepleri ➕ ikonuyla \"kullanım\" yapma (ticket'taki miktar kadar)",
    ],
    steps: [
      "Sol menüden Tickets sayfasını açın.",
      "Üstte User ID, Boost Kategorisi, Boost Tipi ve Durum filtrelerini ihtiyacınıza göre seçin.",
      "Bilgi Getir'e tıklayın; sonuçlar tabloda listelenir.",
      "Durumu değiştirmek için satırdaki ✅ (Onayla) veya ❌ (Reddet) ikonuna tıklayın.",
      "OPEN veya APPROVED durumlu kayıtlarda 👁️ ikonuyla ticket'ı görüntüleyebilir, 💬 ikonuyla kullanıcıyla mesajlaşabilirsiniz.",
      "Ticket onaylandıysa ➕ ikonuyla \"kullanım\" yapın; sistem ticket'taki miktar kadar işlemi uygular.",
    ],
    iconLegend: [
      "👁️ Görüntüle: Ticket detayını açar (OPEN & APPROVED)",
      "💬 Mesaj: Kullanıcıyla yazışma başlatır (OPEN & APPROVED)",
      "✅ Onayla: Durumu APPROVED yapar",
      "❌ Reddet: Durumu REJECTED yapar",
      "➕ Kullanım: Onaylı ticket'ı kullandırır (yalnızca APPROVED)",
    ],
    tips: [
      "Onaylamadan önce 'İstenen Miktar' ve 'Kullanıcı Notu' alanlarını kontrol edin.",
      "Bir ticket'ı reddetmeden önce mümkünse kullanıcıyla mesajlaşarak sebebi paylaşın.",
      "Sayfa başına satır ile sayfadaki kayıt sayısını ayarlayabilir, oklarla sayfalar arasında gezebilirsiniz.",
    ],
  },
  {
    id: "feedback-tickets",
    title: "Feedback Tickets",
    menuPath: "Admin Paneli → Feedback Tickets",
    purpose:
      "Müşteri geri bildirim taleplerini listeleme, durumlarına göre filtreleme, detaylarına girip yanıt verme ve statü yönetimi yapma.",
    actions: [
      "Tüm feedback taleplerini listeleme",
      "Müşteri e-postasına göre arama yapma (debounce ile)",
      "Duruma göre (Açık, Beklemede, İnceleniyor, Çözüldü, Kapalı) filtreleme",
      "Tablo üzerinden konu, kategori ve durum bilgilerini görüntüleme",
      "Detay ekranında müşteriyle mesajlaşma ve statüyü değiştirme",
      "Yeni mesaj geldiğinde otomatik güncellenen konuşma akışını izleme",
      "Manuel yenileme veya daha fazla mesaj yükleme (sayfalama) işlemleri"
    ],
    steps: [
      "Sol menüden Admin Paneli → Feedback Tickets bağlantısına tıklayın.",
      "Üstteki e-posta alanına kullanıcı adresini yazarak arama yapabilir; durum açılır menüsünden filtre seçebilirsiniz.",
      "Listeyi yenilemek için sağ üstteki yenile ikonunu kullanın; sonuçlar tablonun altında sayfa sayfa görüntülenir.",
      "İlgili talebin üzerine tıklayarak detay görünümünü açın. Müşteri ile geçmiş mesajları inceleyin.",
      "Metin kutusuna yanıtınızı yazıp Gönder butonuna basın; mesaj gönderilirken buton devre dışı kalır.",
      "Başlıktaki durum açılır menüsünden talebin statüsünü değiştirebilir, değişiklik sonrası bilgilendirme alabilirsiniz.",
      "Konuşma alanındaki 'Daha fazla mesaj yükle' butonu ile eski mesajları çekebilir, ihtiyaç halinde Yenile butonunu kullanabilirsiniz."
    ],
    iconLegend: [
      "📧 E-posta filtresi: Müşteri adresine göre arama yapar.",
      "🔄 Yenile: Liste veya detay ekranını yeniden yükler.",
      "💬 Gönder: Personel yanıtını iletir (boş bırakıldığında uyarı üretir).",
      "⬇️ Daha fazla mesaj: Konuşmadaki önceki mesajları getirir."
    ],
    tips: [
      "Filtrelerde değişiklik yaptığınızda liste otomatik yenilenir; arama alanı 400 ms gecikme ile çalışır.",
      "Detay ekranı 15 saniyede bir yeni müşteri mesajlarını kontrol eder; uzun süre açık bırakabilirsiniz.",
      "Durum değişiklikleri tabloya otomatik yansır; sayfayı manuel yenilemenize gerek kalmaz.",
      "Tablodaki kayıtlar arasından ihtiyacınız olan ticket'ı açıp detay ekranından müşteriyle iletişime geçebilirsiniz."
    ],
  },
  {
    id: "announcements",
    title: "Duyurular",
    menuPath: "Admin Paneli → Duyurular",
    purpose:
      "Duyuruları listeleme, kategoriye göre filtreleme, yeni duyuru oluşturma ve mevcut duyuruları düzenleme.",
    actions: [
      "Tüm duyuruları listeleme",
      "Kategoriye göre filtreleme",
      "Yeni duyuru ekleme (başlık, slug, kategori, içerik, link)",
      "Mevcut duyuruları düzenleme (başlık, içerik, link, kategori, durum)",
      "Kategori yönetimi: kategori ekleme/düzenleme/sıra değiştirme (Kategori butonu üzerinden)"
    ],
    steps: [
      "Sol menüden Duyurular sayfasını açın.",
      "İsterseniz kategori filtresinden bir kategori seçip listeyi daraltın.",
      "Yeni duyuru eklemek için sağ üstteki 'Yeni Duyuru' butonuna tıklayın.",
      "Açılan formda Başlık, (opsiyonel) Slug, Kategori, İçerik alanlarını doldurun. Gerekirse dış link ekleyin.",
      "Durum ve Yayın Tarihi alanlarını belirleyip Kaydet'e basın.",
      "Var olan bir duyuruyu düzenlemek için satırdaki ✏️ ikonuna tıklayın ve bilgileri güncelleyip kaydedin.",
      "Kategori eklemek veya sıralamayı değiştirmek için 'Kategoriler' butonuna tıklayın; açılan pencereden yeni kategori ekleyebilir veya mevcutların sırasını güncelleyebilirsiniz."
    ],
    tips: [
      "Slug boş bırakılırsa başlıktan otomatik üretilir.",
      "Link URL doldurursanız dış bağlantı olarak çalışır; boş bırakacaksanız link alanını temiz tutun.",
      "Pinned seçeneği listede duyuruyu üstte gösterir; kritik duyurular için kullanın.",
      "Yayın Tarihi gelecekte ise duyuru zamanlanır, geçmiş veya şimdi ise hemen yayınlanır.",
      "Kategori sırası çakışırsa hata alırsınız; her kategori için benzersiz sıra değeri kullanın."
    ],
  }
];

export default function HowToUse() {
  const [active, setActive] = useState(PAGES[0]?.id);
  const current = PAGES.find((p) => p.id === active);

  return (
    <div className="mx-auto max-w-6xl p-6 space-y-8">
      <header className="space-y-3">
        <h1 className="text-3xl font-bold tracking-tight">Onsa Admin Panel — Kullanım Kılavuzu</h1>
        <p className="text-sm text-gray-600">
          Paneldeki ekranları adım adım öğrenin. Sol menüden bir bölüm seçin.
        </p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <nav className="md:col-span-1 space-y-2">
          <div className="rounded-2xl border p-3">
            <p className="text-xs font-medium uppercase text-gray-500 mb-2">Bölümler</p>
            <ul className="space-y-2">
              {PAGES.map((p) => (
                <li key={p.id}>
                  <button
                    onClick={() => setActive(p.id)}
                    className={`w-full text-left px-3 py-2 rounded-xl transition border ${active === p.id
                      ? "bg-gray-100 border-gray-300"
                      : "hover:bg-gray-50 border-transparent"
                      }`}
                  >
                    <div className="text-sm font-medium">{p.title}</div>
                    <div className="text-[11px] text-gray-500">{p.menuPath}</div>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </nav>

        <main className="md:col-span-3 space-y-6">
          {current && (
            <section className="rounded-2xl border p-5 space-y-4">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <h2 className="text-xl font-semibold">{current.title}</h2>
                  <p className="text-sm text-gray-600">Amaç: {current.purpose}</p>
                </div>
                <span className="text-xs px-2 py-1 rounded-full border bg-white">Konum: {current.menuPath}</span>
              </div>

              {current.id === 'manage-boosts' && current.rules?.length > 0 && (
                <div className="rounded-xl border p-4">
                  <h3 className="font-medium">Genel Boost Yapısı</h3>
                  <ul className="mt-2 space-y-1 text-sm list-disc pl-5">
                    {current.rules.map((a, i) => (
                      <li key={i}>{a}</li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                <div className="rounded-xl border p-4">
                  <h3 className="font-medium">Kullanım Adımları</h3>
                  <ol className="list-decimal pl-5 mt-2 space-y-1 text-sm">
                    {current.steps?.map((s, i) => (
                      <li key={i}>{s}</li>
                    ))}
                  </ol>
                </div>
                <div className="rounded-xl border p-4">
                  <h3 className="font-medium">Yapabilecekleriniz</h3>
                  <ul className="mt-2 space-y-1 text-sm list-disc pl-5">
                    {current.actions?.map((a, i) => (
                      <li key={i}>{a}</li>
                    ))}
                  </ul>
                </div>
                <div className="rounded-xl border p-4 lg:col-span-2">
                  <h3 className="font-medium">İkonlar</h3>
                  <ul className="mt-2 space-y-1 text-sm list-disc pl-5">
                    {current.iconLegend?.map((iText, i) => (
                      <li key={i}>{iText}</li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="rounded-2xl border p-5 space-y-3">
                <h3 className="text-xl font-semibold">İpuçları</h3>
                <ul className="mt-1 space-y-1 text-sm list-disc pl-5">
                  {current.tips?.map((t, i) => (
                    <li key={i}>{t}</li>
                  ))}
                </ul>
              </div>
            </section>
          )}
        </main>
      </div>
    </div>
  );
}
